import gql from 'graphql-tag';

import actionTypes from './constants';

/* */
export const get = (client, variables, fetchPolicy = 'no-cache') => client
    .query({
      query: gql`
        ${actionTypes.gql.GET}
      `,
      fetchPolicy,
      variables,
    })
    .then((res) => res.data)
    .then((data) => data.getAccountWallet);

/* */
export const getRefills = (client, variables, fetchPolicy = 'no-cache') => client
    .query({
      query: gql`
        ${actionTypes.gql.GET_ACCOUNT_WALLET_REFILLS}
      `,
      fetchPolicy,
      variables,
    })
    .then(({ data }) => data.getAccountWalletRefills);

/* */
export const createOperation = (client, variables) => client
    .mutate({
      mutation: gql`
        ${actionTypes.gql.CREATE_ACCOUNT_WALLET_OPERATION}
      `,
      variables,
    })
    .then(({ data }) => data.createAccountWalletOperation);
